<template>
  <v-row align="center">
    <v-col v-if="addArrowBack" cols="auto" class="pr-0">
      <v-icon @click="$router.push({ path: `/` })">
        arrow_back
      </v-icon>
    </v-col>

    <v-col cols="auto" class="py-2">
      <v-toolbar-title>{{ label }}</v-toolbar-title>
    </v-col>

    <v-divider v-if="divider" vertical />

    <v-col v-if="$slots.sync" cols="auto" class="py-2">
      <slot name="sync" />
    </v-col>

    <v-col v-if="!disabled" cols="auto" class="py-2">
      <v-btn
        class="primary-button"
        :loading="loading"
        @click="isModal ? (openModal = true) : $emit('add')"
      >
        {{ btnText }}
      </v-btn>
      <ModalWindow
        :id="0"
        v-model="openModal"
        :component-name="componentName"
        @close="openModal = false"
      />
    </v-col>

    <v-col :cols="isHeaderFilter ? 'X' : '6'" class="py-2">
      <Search
        v-if="searchField"
        v-model="search"
        :title="searchLabel"
        :clearable="clearable"
        data-test="search"
        @input="$emit('getSearch', search)"
      />
    </v-col>

    <slot name="setting-buttons" />

    <v-col v-if="$slots.filters" cols="12" class="px-0 py-1">
      <slot name="filters" />
    </v-col>

    <v-col v-if="$slots.totals" class="px-0 py-0">
      <slot name="totals" />
    </v-col>
  </v-row>
</template>

<script>
import Search from "./Search.vue";
import ModalWindow from "@/components/ModalWindow.vue";

export default {
  components: {
    Search,
    ModalWindow,
  },
  props: {
    label: String,
    btnLabel: String,
    searchLabel: String,
    disabled: Boolean,
    searchField: { type: Boolean, default: true },
    isHeaderFilter: { type: Boolean },
    clearable: Boolean,
    divider: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    searchValue: {
      type: String,
      default: "",
    },
    addArrowBack: {
      type: Boolean,
      default: false,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    componentName: String,
  },
  data: () => ({
    search: "",
    openModal: false,
  }),
  computed: {
    btnText() {
      return this.btnLabel || "Додати";
    },
  },
  watch: {
    searchValue: {
      handler(val) {
        this.search = val;
      },
      immediate: true,
    },
  },
};
</script>
